import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { TokenStorageService } from './token-storage-service';
import { ConfigService } from '../services/config.service';
import { BehaviorSubject } from 'rxjs';
import { CurrentUserService } from '../services/current-user.service';

@Injectable()
export class CanActivateAuthGuard implements CanActivate {
  isProduction: boolean;
  isSessionInitInProgress = new BehaviorSubject<boolean>(false);

  constructor(
    private currentUserService: CurrentUserService,
    private tokenStorageService: TokenStorageService,
    private configService: ConfigService
  ) {
    this.configService.getConfig().then(envConfig => {
      this.isProduction = envConfig.production;
    });
  }

  async canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    return await this.getBool(state)
  }

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    return await this.getBool(state)
  }

  private async getBool(state): Promise<boolean> {
    if (await this.tokenStorageService.validateSession()) {
      return this.checkURL(state.url);
    } else {
      return false;
    }
  }

  private async checkURL(url): Promise<boolean> {
    let entitlements = await this.currentUserService.getEntitlements();
    if (url.includes('add-customer-user') && entitlements['HC_CUSTOMER_CREATE_USER']) {
      return true;
    } else if (url.includes('add-supplier-user') && entitlements['HC_SUPPLIER_CREATE_USER']) {
      return true;
    } else if (url.includes('add-carrier-user') && entitlements['HC_CR_CREATE_USER']) {
      return true;
    } else if (url.includes('update-carrier-user') && entitlements['HC_CR_UPDATE_USER']) {
      return true;
    } else if (url.includes('update-customer-user') && entitlements['HC_CUSTOMER_UPDATE_USER']) {
      return true;
    } else if (url.includes('update-supplier-user') && entitlements['HC_SUPPLIER_UPDATE_USER']) {
      return true;
    } else if (url.includes('users') && (entitlements['HC_INTERNAL_VIEW_USER'] ||
      entitlements['HC_INTERNAL_UPDATE_USER'] ||
      entitlements['HC_CUSTOMER_VIEW_USER'] ||
      entitlements['HC_CUSTOMER_UPDATE_USER'] ||
      entitlements['HC_SUPPLIER_VIEW_USER'] ||
      entitlements['HC_SUPPLIER_UPDATE_USER'] ||
      entitlements['HC_CR_VIEW_USER'] ||
      entitlements['HC_CR_UPDATE_USER'])) {
      return true;
    } else if (url.includes('customer') && entitlements['HC_INTERNAL_VIEW_CUSTOMERS']) {
      return true;
    } else if (url.includes('supplier') && entitlements['HC_INTERNAL_VIEW_SUPPLIERS']) {
      return true;
    } else if (url.includes('requests') && entitlements['HC_INTERNAL_VIEW_REQUESTS']) {
      return true;
    } else if (this.currentUserService.isInternalAdmin) {
      return true;
    } else {
      return false;
    }
  }
}
